import React from "react";
import Slider from "react-slick";
import BannerSlider from '../component/Banner'
export const Brands = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200, // Large screens (≤1200px)
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992, // Medium screens (≤992px)
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, // Small screens (≤768px)
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="container pb-5">
        {/* <Slider {...settings} className="brands-slider mb-5">
          <div className="brand-item">
            <div className="brand-image-wrapper">
              <img src="/images/Mask group (1).png" alt="Slide 1" />
            </div>
          </div>
          <div className="brand-item">
            <div className="brand-image-wrapper">
              <img src="/images/Mask group (2).png" alt="Slide 2" />
            </div>
          </div>
          <div className="brand-item">
            <div className="brand-image-wrapper">
              <img src="/images/Mask group (3).png" alt="Slide 3" />
            </div>
          </div>
          <div className="brand-item">
            <div className="brand-image-wrapper">
              <img src="/images/Mask group.png" alt="Slide 4" />
            </div>
          </div>
          <div className="brand-item">
            <div className="brand-image-wrapper">
              <img src="/images/sorare.png" alt="Slide 5" />
            </div>
          </div>
        </Slider> */}
                <BannerSlider/>

      </div>
    </>
  );
};